/** @jsx jsx */
import { css } from "@emotion/react";

export const fazemosParteDaRedeBertoniStyles = css` 
  background-color: #F7FAF8;
  padding: 120px 0px;
  overflow: clip;
  scroll-margin-top: 70px;

  @media only screen and (max-width: 600px) {
    padding: 60px 0; 
  }

  .title-sec {
    margin-bottom: 56px;
  }

  h2 {
    color: #3C3C3C;
    font-family: Montserrat;
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
    span {
      color: #F26F33;
      font-weight: 600;
    }
  }

  p {
    color: #686868;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    margin-bottom: 0px;
  }
  
  .img {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 120px;
  }
`